import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox as AriaCheckbox } from '@ariakit/react';
import { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { CheckboxCheckmark, CheckboxDisabled, Minus } from '../Icons';
import * as Styles from './styles';
const Checkbox = ({ children, checked, indeterminate = false, disabled, hover, ...rest }) => {
    const { color } = useTheme();
    const filled = checked || indeterminate;
    return (_jsxs(_Fragment, { children: [_jsx(Styles.Checkbox, { "$filled": filled, "$disabled": disabled, "$hover": hover && !indeterminate && !disabled, ...rest, children: disabled && !filled ? (_jsx(CheckboxDisabled, { "aria-hidden": true })) : indeterminate ? (_jsx(Minus, { "aria-hidden": true, height: '10px', stroke: disabled ? color.stroke.disabled.text.on.background : 'white', viewBox: '0 0 12 2', width: '10px' })) : (_jsx(CheckboxCheckmark, { "aria-hidden": true, fill: disabled ? color.stroke.disabled.text.on.background : undefined })) }), children] }));
};
const Label = ({ children, disabled, ...rest }) => {
    return (_jsx(Styles.Label, { "$disabled": disabled, ...rest, children: children }));
};
const Input = forwardRef(function Input({ disabled, indeterminate, checked, ...rest }, ref) {
    return (_jsx(AriaCheckbox, { ref: ref, disabled: disabled, accessibleWhenDisabled: true, checked: indeterminate ? 'mixed' : checked, render: _jsx(Styles.HiddenInput, {}), ...rest }));
});
export const StyledCheckbox = {
    Checkbox,
    Label,
    Input,
    AriaKitCheckbox: Styles.AriaKitCheckbox,
};
//# sourceMappingURL=index.js.map